import { useSettings } from "@/lib/SettingsContext";

/**
 * Returns true when the featured event should be surfaced across the site
 * (announcement bar + home banner). Encapsulates the active-flag + end-date
 * guard so every consumer stays in sync.
 */
export const useShowEvent = () => {
  const { event } = useSettings();
  if (!event || !event.active) return false;
  if (!event.end_date) return true;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const end = new Date(`${event.end_date}T23:59:59`);
  return !isNaN(end.getTime()) && end.getTime() >= today.getTime();
};
